import { createSlice, Reducer, Slice } from "@reduxjs/toolkit";

import { VOLUME_FORECAST_TAB_ID, PROMOTION_PLANNING_TAB_ID, FORECAST_REVIEW_TAB_ID, ANNUAL_SUMMARY_TAB_ID, TRADE_SPEND_REPORT_TAB_ID, SHORT_TERM_PROMOTION_SUB_TAB_ID, LONG_TERM_PROMOTION_SUB_TAB_ID, TPP_DEFAULT_CUSTOMER_ID } from "../../shared/constants";
import TradeAndPromoPlanningTabSlice from "../../models/Redux/TradeAndPromoPlanningTabSlice.model";

const initialTabApiDataFetchedState: {
    [key: string]: boolean;
} = {
    [VOLUME_FORECAST_TAB_ID]: false,
    [PROMOTION_PLANNING_TAB_ID]: false,
    [LONG_TERM_PROMOTION_SUB_TAB_ID]: false,
    [SHORT_TERM_PROMOTION_SUB_TAB_ID]: false,
    [FORECAST_REVIEW_TAB_ID]: false,
    [ANNUAL_SUMMARY_TAB_ID]: false,
    [TRADE_SPEND_REPORT_TAB_ID]: false
}

const initialState: TradeAndPromoPlanningTabSlice = {
    activeSubTabId: VOLUME_FORECAST_TAB_ID,
    globalCustomer: {
        id: TPP_DEFAULT_CUSTOMER_ID,
        name: "TARGET"
    },
    tabApiDataFetched: initialTabApiDataFetchedState
};

const tradeAndPromoPlanningTabSlice: Slice = createSlice({
    name: "tradeAndPromoPlanningTab",
    initialState,
    reducers: {
        setActiveSubTabId: (state, action: { payload: string }) => {
            state.activeSubTabId = action.payload;
        },
        setTabApiDataFetched: (state, action: { payload: { [key: string]: boolean; } }) => {
            state.tabApiDataFetched = {
                ...state.tabApiDataFetched,
                ...action.payload
            };
        },
        setGlobalCustomer: (state: TradeAndPromoPlanningTabSlice, action: { payload: { id: number; name: string; } }) => {
            state.globalCustomer = action.payload;
        },
        resetTabApiDataFetched: (state, action) => {
            state.tabApiDataFetched = initialTabApiDataFetchedState;
        }
    }
});

export const tradeAndPromoPlanningTabActions = tradeAndPromoPlanningTabSlice.actions;

export default tradeAndPromoPlanningTabSlice.reducer as Reducer<TradeAndPromoPlanningTabSlice>;
